import { render, staticRenderFns } from "./PlanAccountTable.vue?vue&type=template&id=54ce031c"
import script from "./PlanAccountTable.vue?vue&type=script&lang=js"
export * from "./PlanAccountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports